import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import CheckBoxInput from '../common/input/CheckBoxInput';
import { userMrktAction, userMrktInfoAction } from '../../modules/su/userInfoModule';
import Modal from 'react-modal';
import { customModalStyles } from '../common/popup/NormalPopup';
import NormalPopupOneBtn from '../common/popup/NormalPopupOneBtn';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MySettingMkTableBlock = styled.table`

    border-top: 2px solid #111;
    border-bottom: 1px solid #ccc;
    width: 100%;

    th {
        padding: 13px 5px 14px;
        font-size: 14px;
        text-align: center;
    }

    td {
        //line-height: 1.5;
        position: relative;
        padding: 20px;
        border-top: 1px solid #ccc;
        vertical-align: middle;
        font-size: 15px;
      }

      td.border_bottom {
        border-bottom: 1px solid #ccc;
      }

      td.border_right {
        border-right: 1px solid #ccc;
      }

      td.border_black {
        border-bottom: 1px solid #111;
      }

      td.border_none {
        border-top: none;
      }

      td.border_t-none {
        border-top: none;
      }

      td.padding_none {
        padding: 6px 0;
      }

      td.thumb_none {
        padding-left: 120px;
      }

      b {
        font-weight: 700;
      }

      .mint {
        background-color: rgba(0, 217, 184, 0.1);
      }

      .gray {
        background-color: #f4f4f4;
      }

      .input-box .text-input:disabled {
        color: #999;
        background-color: #e7e7e7;
      }
`;

const MySettingMkTable = () => {

  const dispatch = useDispatch();

  // Check box value
  const [smsCh, setSmsCh] = useState(false);
  const [emailCh, setEmailCh] = useState(false);
  const [kakaoCh, setKakaoCh] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const { code, mrkt_email_yn, mrkt_sms_yn,
    mrkt_kakao_yn, msg1, msg2, msg3, loading, action } = useSelector(
      ({ userInfoReducer, loadingReducer }) => ({
        code: userInfoReducer.code,
        mrkt_email_yn: userInfoReducer.mrkt_email_yn,
        mrkt_sms_yn: userInfoReducer.mrkt_sms_yn,
        mrkt_kakao_yn: userInfoReducer.mrkt_kakao_yn,
        msg1: userInfoReducer.msg1,
        msg2: userInfoReducer.msg2,
        msg3: userInfoReducer.msg3,
        action: userInfoReducer.action,
        loading: loadingReducer['userinfo/MRKT']
      })
    );

  useEffect(() => {

    if (code !== null) {
      setSmsCh(mrkt_sms_yn ? true : false);
      setEmailCh(mrkt_email_yn ? true : false);
      setKakaoCh(mrkt_kakao_yn ? true : false);
    }

  }, [code])

  useEffect(() => {
    // 팝업 표시
    if (action === 'userinfo/MRKT_SUCCESS') {
      setOpenModal(true);
    }
  }, [msg1, msg2, msg3])

  const handleSmsClick = () => {
    if (!loading) {
      dispatch(userMrktAction(!smsCh, null, null));
      setSmsCh(!smsCh);
    }
  }

  const handleEmailClick = () => {
    if (!loading) {
      dispatch(userMrktAction(null, !emailCh, null));
      setEmailCh(!emailCh);
    }
  }

  const handleKakaoClick = () => {

    if (!loading) {
      dispatch(userMrktAction(null, null, !kakaoCh));
      setKakaoCh(!kakaoCh);
    }

  }

  const handleOneBtnPopupClick = () => {
    setOpenModal(false);
    dispatch(userMrktInfoAction());
  }

  return (
    <div>
      {isMobileOnly ?
      <MySettingMkTableBlock style = {{width: '100%'}}>
        <colgroup>
          <col width="50%" />
          <col width="50%" />
        </colgroup>

        <tbody>
          <tr>
            {/* <td >
              <CheckBoxInput title="문자"
                onClick={handleSmsClick}
                defaultValue={smsCh}
                labelmargin="0px 0px 0px 7px" />
            </td> */}
            <td >
              <CheckBoxInput title="이메일"
                onClick={handleEmailClick}
                defaultValue={emailCh}
                labelmargin="0px 0px 0px 7px" />
            </td>
            <td >
              <CheckBoxInput title="카카오채널"
                onClick={handleKakaoClick}
                defaultValue={kakaoCh}
                labelmargin="0px 0px 0px 7px" />
            </td>
          </tr>
        </tbody>

        <Modal
          isOpen={openModal}
          onRequestClose={handleOneBtnPopupClick}
          style={customModalStyles}
          onAfterOpen={() => document.body.style.overflow = 'hidden'}
          onAfterClose={() => document.body.removeAttribute('style')}>

          <NormalPopupOneBtn
            text={msg1}
            text2={msg2} text3={msg3}
            btn="닫기" onClick={handleOneBtnPopupClick} />

        </Modal>
      </MySettingMkTableBlock>
      :
      <MySettingMkTableBlock>
        <colgroup>
          <col width="180px" />
          <col width="756px" />
        </colgroup>

        <tbody>
          <tr>
            {/* <td >
              <CheckBoxInput title="문자"
                onClick={handleSmsClick}
                defaultValue={smsCh}
                labelmargin="0px 0px 0px 7px" />
            </td> */}
            <td >
              <CheckBoxInput title="이메일"
                onClick={handleEmailClick}
                defaultValue={emailCh}
                labelmargin="0px 0px 0px 7px" />
            </td>
            <td >
              <CheckBoxInput title="카카오채널"
                onClick={handleKakaoClick}
                defaultValue={kakaoCh}
                labelmargin="0px 0px 0px 7px" />
            </td>
          </tr>
        </tbody>

        <Modal
          isOpen={openModal}
          onRequestClose={handleOneBtnPopupClick}
          style={customModalStyles}
          onAfterOpen={() => document.body.style.overflow = 'hidden'}
          onAfterClose={() => document.body.removeAttribute('style')}>

          <NormalPopupOneBtn
            text={msg1}
            text2={msg2} text3={msg3}
            btn="닫기" onClick={handleOneBtnPopupClick} />

        </Modal>
      </MySettingMkTableBlock>
      }

    </div>
  );
};

export default MySettingMkTable;
